import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { translate } from "../../../intl";

interface FileAttachErrorBoxProps {
  maxFiles: number;
}

const FileAttachErrorBox: React.FC<FileAttachErrorBoxProps> = ({ maxFiles }) => (
  <div
    className="file-attach__error-box file-attach__error-box--anchored"
    role="alert"
    aria-live="assertive"
  >
    <FontAwesomeIcon icon={faExclamationCircle} className="file-attach__error-icon" />
    <div className="file-attach__error-text">
      <span className="file-attach__error-main">
        {translate("genericComponents.file.error.boxTitle")}
      </span>
      <span className="file-attach__error-detail">
        {translate("genericComponents.file.error.boxText", { maxFilesNum: maxFiles.toString() })}
      </span>
    </div>
  </div>
);

export default FileAttachErrorBox;
